import {_ReactPixi, Container} from '@inlet/react-pixi';
import React, {FunctionComponent} from 'react';
import {Point} from 'pixi.js';
import {ScreenParameters} from '@gongxigames/framework/core/fragments/ScreenParameters';

export type StickyTo =
    'none' |
    'top' |
    'bottom' |
    'left' |
    'right' |
    'top-left' |
    'top-right' |
    'bottom-left' |
    'bottom-right' |
    'center';

export type ScreenStickyProps = Omit<_ReactPixi.IContainer, 'position'> & {
    screenParameters: ScreenParameters;
    position?: [x: number, y: number];
    fullscreen?: boolean;
    stickyTo: StickyTo;
};

export const ScreenSticky: FunctionComponent<ScreenStickyProps> = (props) => {
    const {position = [0, 0], stickyTo = 'center', fullscreen} = props;
    const stickyPosition = props.screenParameters.getStickyPosition(new Point(...position), stickyTo, fullscreen);

    return <Container name={`ScreenSticky-${stickyTo}`} {...props} position={stickyPosition}>
        {props.children}
    </Container>;
};
